import React from 'react'

function NotesFoundIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="402"
            height="400"
            fill="none"
            viewBox="0 0 402 400"
        >
            <g clipPath="url(#clip0_6556_17794)">
                <path
                    fill="#E6E6E6"
                    d="M265.116 105.975h-65.971a9.501 9.501 0 01-7.5-3.635 9.62 9.62 0 01-1.8-8.246 166.802 166.802 0 00-.001-77.474 9.627 9.627 0 011.801-8.246 9.498 9.498 0 017.5-3.635h65.971a9.617 9.617 0 019.463 8.07 279.578 279.578 0 010 85.095 9.618 9.618 0 01-9.463 8.071z"
                ></path>
                <path
                    fill="#fff"
                    d="M199.146 9.703a4.56 4.56 0 00-3.602 1.744 4.683 4.683 0 00-.872 4.015 171.792 171.792 0 010 79.79 4.689 4.689 0 00.871 4.014 4.568 4.568 0 003.603 1.745h65.97a4.62 4.62 0 004.558-3.86 274.687 274.687 0 000-83.587 4.62 4.62 0 00-4.558-3.861h-65.97z"
                ></path>
                <path
                    fill="#E6E6E6"
                    d="M250.719 33.57H216.1a4.969 4.969 0 01-4.963-4.963v-1.94a4.969 4.969 0 014.963-4.963h34.619a4.969 4.969 0 014.963 4.963v1.94a4.965 4.965 0 01-4.963 4.964zM250.719 58.08H216.1a4.97 4.97 0 01-4.963-4.963v-1.94a4.969 4.969 0 014.963-4.964h34.619a4.969 4.969 0 014.963 4.964v1.94a4.965 4.965 0 01-4.963 4.963zM250.719 82.59H216.1a4.97 4.97 0 01-4.963-4.964v-1.94a4.97 4.97 0 014.963-4.963h34.619a4.97 4.97 0 014.963 4.963v1.94a4.965 4.965 0 01-4.963 4.964zM389.211 168.85h-65.97a9.501 9.501 0 01-7.5-3.635 9.61 9.61 0 01-1.801-8.246 166.804 166.804 0 000-77.475 9.613 9.613 0 011.801-8.246 9.488 9.488 0 017.5-3.634h65.97a9.615 9.615 0 019.464 8.07 279.64 279.64 0 010 85.095 9.618 9.618 0 01-9.464 8.071z"
                ></path>
                <path
                    fill="#fff"
                    d="M323.242 72.577a4.56 4.56 0 00-3.603 1.745 4.682 4.682 0 00-.871 4.015 171.79 171.79 0 010 79.789 4.675 4.675 0 00.871 4.015 4.566 4.566 0 003.603 1.745h65.97a4.622 4.622 0 004.557-3.861 274.625 274.625 0 000-83.587 4.619 4.619 0 00-4.557-3.86h-65.97z"
                ></path>
                <path
                    fill="#F2F2F2"
                    d="M257.67 240.411H191.7a9.898 9.898 0 01-7.825-3.792 10.025 10.025 0 01-1.878-8.599 166.395 166.395 0 000-77.281 10.01 10.01 0 01-.055-4.516 10.01 10.01 0 011.933-4.083 9.909 9.909 0 017.825-3.792h65.97a10.029 10.029 0 019.872 8.421 280.02 280.02 0 010 85.221 10.03 10.03 0 01-9.872 8.421z"
                ></path>
                <path
                    fill="#E6E6E6"
                    d="M374.814 108.855h-34.618a4.968 4.968 0 01-4.964-4.963v-1.94a4.97 4.97 0 014.964-4.964h34.618a4.971 4.971 0 014.964 4.964v1.94a4.97 4.97 0 01-4.964 4.963zM374.814 133.365h-34.618a4.969 4.969 0 01-4.964-4.964v-1.94a4.97 4.97 0 014.964-4.963h34.618a4.972 4.972 0 014.964 4.963v1.94a4.968 4.968 0 01-4.964 4.964z"
                ></path>
                <path
                    fill="#fff"
                    d="M224.87 208.066c10.509 0 19.028-8.519 19.028-19.028 0-10.509-8.519-19.028-19.028-19.028-10.509 0-19.028 8.519-19.028 19.028 0 10.509 8.519 19.028 19.028 19.028z"
                ></path>
                <path
                    fill="#E6E6E6"
                    d="M233.97 186.556h-6.619v-6.618a2.48 2.48 0 00-2.482-2.482 2.485 2.485 0 00-2.482 2.482v6.618h-6.618a2.484 2.484 0 00-1.755 4.237 2.48 2.48 0 001.755.727h6.618v6.619a2.484 2.484 0 004.964 0v-6.619h6.619a2.481 2.481 0 100-4.964z"
                ></path>
                <path
                    fill="#CCC"
                    d="M248.862 14.064h-34.747a3.727 3.727 0 01-3.722-3.723V3.723A3.726 3.726 0 01214.115 0h34.747a3.727 3.727 0 013.723 3.723v6.618a3.727 3.727 0 01-3.723 3.723zM374.61 77.766h-34.747a3.726 3.726 0 01-3.722-3.723v-6.618a3.726 3.726 0 013.722-3.723h34.747a3.727 3.727 0 013.723 3.723v6.618a3.727 3.727 0 01-3.723 3.723z"
                ></path>
                <path
                    fill="#FFB8B8"
                    d="M73.295 389.709h10.142l3.171-39.121H73.293l.002 39.121z"
                ></path>
                <path
                    fill="#2F2E41"
                    d="M70.709 386.398l19.974-.001h.001a12.724 12.724 0 0111.76 7.858c.64 1.544.969 3.2.969 4.871v.414l-32.703.001-.001-13.143z"
                ></path>
                <path
                    fill="#FFB8B8"
                    d="M18.693 389.709h10.143l4.825-39.121h-14.97l.002 39.121z"
                ></path>
                <path
                    fill="#2F2E41"
                    d="M16.107 386.398l19.975-.001a12.724 12.724 0 019.001 3.728 12.735 12.735 0 013.729 9.001v.414l-32.704.001v-13.143zM20.493 377.351a4.126 4.126 0 01-2.792-1.091 4.108 4.108 0 01-1.337-2.926l-4.067-145.782 57.755 14.438 17.82 53.459a58.291 58.291 0 012.933 21.364l-2.213 51.82a4.132 4.132 0 01-4.132 3.936h-9.687a4.155 4.155 0 01-4.099-3.581l-6.924-57.201a31.292 31.292 0 00-4.576-12.546l-13.625-21.572a.826.826 0 00-1.312-.115.828.828 0 00-.209.454l-10.692 95.213a4.131 4.131 0 01-3.878 3.637l-8.73.485a3.702 3.702 0 01-.235.008z"
                ></path>
                <path
                    fill="#FFB8B8"
                    d="M60.44 133.168c11.222 0 20.32-9.097 20.32-20.319s-9.098-20.32-20.32-20.32-20.319 9.098-20.319 20.32 9.097 20.319 20.32 20.319z"
                ></path>
                <path
                    fill="#6C63FF"
                    d="M69.775 247.919c-.35 0-.698-.045-1.036-.132l-57.303-14.692a4.137 4.137 0 01-3.03-4.811l13.16-70.892a25.825 25.825 0 0115.097-18.647 24.917 24.917 0 0123.385 1.716c.802.501 1.61 1.047 2.4 1.623a25.611 25.611 0 0110.407 20.293l1.047 81.347a4.144 4.144 0 01-4.127 4.195z"
                ></path>
                <path
                    fill="#FFB8B8"
                    d="M17.33 248.753a8.315 8.315 0 01.593-10.121 8.311 8.311 0 012.894-2.15l-2.549-29.453 13.507 7.32.35 26.847a8.367 8.367 0 01-4.04 10.35 8.367 8.367 0 01-10.753-2.793z"
                ></path>
                <path
                    fill="#6C63FF"
                    d="M22.158 232.587a4.548 4.548 0 01-4.416-3.441l-6.638-26.378a39.188 39.188 0 013.112-27.412l13.906-27.203a12.856 12.856 0 0115.56-9.116 12.715 12.715 0 017.838 5.874 12.882 12.882 0 011.369 9.856l-19.796 44.266.236 26.503a4.564 4.564 0 01-2.966 4.306l-6.624 2.46a4.54 4.54 0 01-1.581.285z"
                ></path>
                <path
                    fill="#FFB8B8"
                    d="M116.913 237.919a8.312 8.312 0 01-7.285-7.051 8.3 8.3 0 01.259-3.596L85.9 209.99l14.359-5.461 20.577 17.248a8.368 8.368 0 015.208 9.814 8.362 8.362 0 01-9.131 6.328z"
                ></path>
                <path
                    fill="#6C63FF"
                    d="M104.356 225.299a4.557 4.557 0 01-2.037-.481l-24.322-12.175a39.202 39.202 0 01-18.748-20.241l-11.546-28.285a12.861 12.861 0 013.24-17.741 12.687 12.687 0 014.584-2.016 12.687 12.687 0 015.005-.089 12.887 12.887 0 018.34 5.388l20.637 43.88 20.241 17.11a4.57 4.57 0 011.329 5.057l-2.457 6.625a4.55 4.55 0 01-4.266 2.968z"
                ></path>
                <path
                    fill="#2F2E41"
                    d="M56.175 133.479c1.08.473 3.29-8.13 2.3-9.85-1.473-2.559-1.386-2.541-2.364-4.234-.977-1.693-1.196-4.01.07-5.499 1.266-1.49 4.196-1.292 4.774.575-.372-3.547 3.137-6.398 6.613-7.2 3.475-.801 7.141-.304 10.636-1.017 4.056-.827 8.276-4.227 6.657-8.687a6.283 6.283 0 00-1.225-2.014c-1.87-2.102-4.485-3-7.042-3.867-5.32-1.806-10.785-3.634-16.399-3.435a23.823 23.823 0 00-21.052 15.396 21.627 21.627 0 00-.896 3.33c-1.927 10.361 4.09 20.581 13.862 24.527l4.066 1.975z"
                ></path>
                <path
                    fill="#000"
                    d="M32.182 226.137l.46-27.242 14.431-29.015-11.582 29.783-3.31 26.474z"
                    opacity="0.2"
                ></path>
                <path
                    fill="#E6E6E6"
                    d="M163.042 294.505l-60.921-25.312a9.502 9.502 0 01-5.531-6.234 9.617 9.617 0 011.5-8.306 166.806 166.806 0 0029.726-71.545 9.624 9.624 0 018.932-8.125 9.5 9.5 0 014.216.722l60.921 25.312a9.613 9.613 0 015.642 11.084 279.598 279.598 0 01-32.649 78.582 9.615 9.615 0 01-11.836 3.822z"
                ></path>
                <path
                    fill="#fff"
                    d="M139.059 180.289a4.571 4.571 0 00-3.996.228 4.69 4.69 0 00-2.345 3.374 171.8 171.8 0 01-30.614 73.683 4.683 4.683 0 00-.736 4.041 4.563 4.563 0 002.658 2.994l60.921 25.312a4.616 4.616 0 005.69-1.817 274.668 274.668 0 0032.071-77.189 4.617 4.617 0 00-2.728-5.314l-60.921-25.312z"
                ></path>
                <path
                    fill="#6C63FF"
                    d="M171.497 236.634l-31.969-13.282a4.97 4.97 0 01-2.679-6.489l.744-1.791a4.967 4.967 0 016.488-2.679l31.969 13.282a4.97 4.97 0 012.679 6.489l-.744 1.791a4.968 4.968 0 01-6.488 2.679zM162.093 259.268l-31.969-13.283a4.967 4.967 0 01-2.679-6.488l.744-1.791a4.972 4.972 0 016.488-2.68l31.969 13.283a4.967 4.967 0 012.679 6.488l-.744 1.791a4.972 4.972 0 01-6.488 2.68z"
                ></path>
                <path
                    fill="#CCC"
                    d="M184.307 204.825a3.71 3.71 0 01-1.396-.274l-32.214-13.024a3.729 3.729 0 01-2.056-4.846l2.481-6.136a3.723 3.723 0 014.847-2.056l32.213 13.024a3.725 3.725 0 012.056 4.847l-2.48 6.136a3.733 3.733 0 01-3.451 2.329zM116.649 400H.827a.828.828 0 110-1.655H116.65a.827.827 0 010 1.655z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_6556_17794">
                    <path fill="#fff" d="M0 0H401.931V400H0z"></path>
                </clipPath>
            </defs>
        </svg>
    )
}

export default NotesFoundIcon
